import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RegularButton } from 'fronton-react';
import { ChevronDownIcon, ChevronUpIcon } from '@fronton/icons-react';
import { cx } from 'linaria';
import { fadeButton } from './fade-button.styles';
import { FadeButtonProps } from './fade-button.types';

export const FadeButton: FC<FadeButtonProps> = ({ open, onClick, className }) => {
  const { t } = useTranslation();

  return (
    <RegularButton
      className={cx(fadeButton, className)}
      variant="secondary"
      data-qa-fade-arrow-open={!open}
      onClick={onClick}
      label={open ? t('ui.fade-button.open') : t('ui.fade-button.close')}
      rounded
    >
      {open ? <ChevronUpIcon size="s" /> : <ChevronDownIcon size="s" />}
    </RegularButton>
  );
};
